<template>
    <div ref="root">
        <slot :active="active" />
    </div>
</template>

<script setup>
import { onBeforeUnmount, onMounted, ref } from 'vue';

const canObserve = typeof window !== 'undefined' && typeof window.IntersectionObserver === 'function';

const active = ref(!canObserve);
const root = ref(null);
let observer = null;

onMounted(() => {
    if (active.value || !root.value) {
        return;
    }

    observer = new IntersectionObserver((entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) {
            return;
        }
        active.value = true;
        observer.disconnect();
        observer = null;
    }, {
        root: null,
        rootMargin: '600px 0px',
        threshold: 0,
    });

    const target = root.value.closest('.cv-ssr-pair') || root.value;
    observer.observe(target);
});

onBeforeUnmount(() => {
    if (observer) {
        observer.disconnect();
        observer = null;
    }
});
</script>
